<ion-grid class="ion-no-padding">
    <ion-row class="ion-no-padding">
        <ion-col class="ion-no-padding">
            <ion-header>
                <ind-page-title [viewData]='{id:"capture-customer-inquire", title: pageTitle, controls: backButton, isHCPFacing: true}' (onControlClick)='goBack(false)'></ind-page-title>
            </ion-header>
            <ion-content>
                <div class="signature-content">
                    <ind-section-header [viewData]="signatureHeaderModel"></ind-section-header>
                    <div *ngIf="!capturedSignature" class="signature-secondary-message">
                        {{'INQUIRY_PROVIDE_CONSENT' | translate}}
                    </div>
                    <div *ngIf="capturedSignature" class="signature-secondary-message">
                        {{'INQUIRY_AFTER_CONSENT' | translate}}
                    </div>
                    <ion-list class="list-border">
                        <ion-item>
                            <div class="signatureImageContainer" text-center>
                                <div col-1>
                                    <img [src]="'assets/imgs/omni-sign-icon.svg'" class="redSignFlag" />
                                </div>
                                <div *ngIf="!capturedSignature" col-10 class="signature">
                                  <div>
                                      <p (click)="openSignaturePad()" class="sign-text">{{ 'CONSENT_TAP_TO_SIGN' | translate}}</p>
                                  </div>
                              </div>
                              <div *ngIf="capturedSignature" col-10 class="signature-captured">
                                  <div>
                                      <img [src]="capturedSignature" width="auto">
                                   </div>
                              </div>
                            </div>
                        </ion-item>
                    </ion-list>
                </div>

            </ion-content>
            <!-- <ion-footer> -->
            <footer-toolbar *ngIf="(footerService.shouldShowFooter$ | async) && footerService.fabNotRequestedFromPresentation('CaseIntake')" [footerView]="'detailView'" [selectedView]="'inquiryConsent'"></footer-toolbar>
            <!-- </ion-footer> -->
        </ion-col>
    </ion-row>
</ion-grid>
